import { useLocation } from 'react-router-dom';

// Exports
// -------

export default function useIncomingAssessmentId() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search || location.state?.from?.search);
  return searchParams.get('assessment_id');
}
